import React, { useState, useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { GetUser, Alerts } from "../../../helpers";
import { Card } from "react-bootstrap";
import { Table } from "react-bootstrap";
import { FiUser } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import ThemeModal from "../../../components/cmp/ThemeModal";
import UpdateUserForm from "../../../components/users/UpdateUserForm";
import { Formik, ErrorMessage } from "formik";
import OtpTimer from "../../../components/OTP/OtpTimer";
import OtpInput from 'react-otp-input';
const UserSingle = () => {
    const params = useParams();

    const [isLoading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [isEdit, setEdit] = useState(false);
    const [isShowVerify, setShowVerify] = useState(false);
    const [verificationEmail, setVericationEmail] = useState('')
    const [isOtp, setOtp] = useState(false);
    const [isExpired, setExpired] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);


    const getUserDetails = async (id) => {
        const resp = await GetUser.getSinlgeUser(id);
        if (resp && resp.status) {
            setLoading(false);
            setUser(resp.user)
        }
    }

    useEffect(() => {
        getUserDetails(params.user_id)
    }, [params])

    const handleUpdateUser = async (values) => {
        const resp = await GetUser.updateCustomer(values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setEdit(false);
            getUserDetails(params.user_id)
        } else {
            Alerts.alertMessage('Something went wrong !', 'top-right', 'error');
        }

    }

    const handleVerification = async (values, {setSubmitting, resetForm}) => {
        const resp = await GetUser.resentOtp(values);
        if (resp && resp.status) {
            setVericationEmail(resp.email);
            setOtp(true);
            setSubmitting(false);
            resetForm();
        } else {
            setSubmitting(false);
        }
    }
    const handleOtpExpired = () => {
        setExpired(true);
    };

    const verifyOtp = async (values, { setSubmitting, resetForm }) => {
        values.email = verificationEmail;
        values.isVerifyOnly = true;
        const resp = await GetUser.verifyNewUser(values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            setOtp(false);
            setVericationEmail('');
            setShowVerify(false);
             getUserDetails(params.user_id);
        } else {
            setSubmitting(false);
        }
    }

    const resentOtp = async (email) => {
        setResendLoading(true);
        let resp = await GetUser.resentOtp({ email: email });
        if (resp) {
            setResendLoading(false);
            setExpired(false);
        }
    }

    return (
        <>  <div className="innerPageWrapper">
            <div className='container-fluid'>
                <div className='page-title'>
                    <h2><FiUser /> User Details</h2>
                    <Link to={'/app/users'} className="btn btn-success btn-sm"><FaUsers /> Users</Link>
                </div>

                <Card>

                    <Card.Body>
                        {
                            isLoading ? 'Please wait' : <>
                                <Table className='customTable'>
                                    <tbody>
                                        <tr>
                                            <th>Name</th>
                                            <td>{user.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Email</th>
                                            <td>{user.email}</td>
                                        </tr>
                                        <tr>
                                            <th>Mobile Number</th>
                                            <td>{user.mobile_number}</td>
                                        </tr>
                                        {/* <tr>
                                            <th>Gender</th>
                                            <td>{user.gender}</td>
                                        </tr> */}

                                        <tr>
                                            <th>Address</th>
                                            <td>{user.address}</td>
                                        </tr>
                                        <tr>
                                            <th>City</th>
                                            <td>{user.city}</td>
                                        </tr>
                                        <tr>
                                            <th>State</th>
                                            <td>{user.state}</td>
                                        </tr>
                                        <tr>
                                            <th>Pincode</th>
                                            <td>{user.pin_code}</td>
                                        </tr>
                                        <tr>
                                            <th>Country</th>
                                            <td>{user.country}</td>
                                        </tr>
                                        <tr>
                                            <th>Roles</th>
                                            <td>
                                                {user.roles && user.roles.length > 0 && user.roles.map((o, i) => (
                                                    <span key={i}>
                                                        {o}{i < user.roles.length - 1 ? ', ' : ''}
                                                    </span>
                                                ))}
                                            </td>

                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <td>
                                                <div className={`badge ${user.is_active ? "bg-success" : "bg-danger"}`}>
                                                    {user.is_active ? 'Active' : 'Unactive'}
                                                </div>
                                                {!user.is_active && <button className="btn verify-btn btn-sm ml-3" onClick={() => setShowVerify(true)}>click here to verify</button>}

                                            </td>
                                        </tr>

                                    </tbody>
                                </Table>
                                <button className='cPrimaryButton' onClick={() => setEdit(true)}>Edit</button>
                                <ThemeModal show={isEdit} handleHide={() => setEdit(false)} title={'Update User'} isHeader={true} size="lg">
                                    <UpdateUserForm user={user} handleSubmit={handleUpdateUser} />
                                </ThemeModal>
                                <ThemeModal show={isShowVerify} handleHide={() => setShowVerify(false)} title={'Email Verification'}>
                                    {
                                        isOtp ? <div style={{ maxWidth: 300, margin: '25px auto' }}>
                                            <Formik
                                                initialValues={{ otp: "" }}
                                                validate={(values) => {
                                                    const errors = {};
                                                    if (!values.otp) {
                                                        errors.otp = "OTP is required !";
                                                    } else if (values.otp.length !== 6) {
                                                        errors.otp = "OTP should be 6 digit.";
                                                    } else if (isNaN(values.otp)) {
                                                        errors.otp = "OTP should be digits.";
                                                    }
                                                    return errors;
                                                }}
                                                onSubmit={verifyOtp}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    isSubmitting,
                                                    setFieldValue

                                                }) => (
                                                    <form onSubmit={handleSubmit}>
                                                        <h5 style={{ textAlign: 'center' }}>Verify with OTP</h5>
                                                        <p style={{ textAlign: 'center', marginBottom: 15, fontSize: 14 }}>Sent to : {verificationEmail} </p>
                                                        <OtpInput
                                                            value={values.otp}
                                                            onChange={(otp) => setFieldValue('otp', otp)}
                                                            numInputs={6}
                                                            renderSeparator={<span>-</span>}
                                                            renderInput={(props) => <input {...props} />}
                                                            containerStyle={{ justifyContent: 'space-between' }}
                                                            inputStyle={{
                                                                width: '40px',
                                                                height: '40px',
                                                                fontSize: '18px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #ccc',
                                                            }}
                                                        />
                                                        {errors.otp && touched.otp && (
                                                            <div style={{ textAlign: 'center' }}>
                                                                <span className="helpError">{errors.otp}</span>
                                                            </div>

                                                        )}
                                                        {
                                                            resendLoading ? <div style={{ textAlign: 'center', marginTop: 10 }}><Spinner animation="border" variant="dark" size="sm" /> Please wait.. </div> : <>
                                                                <div style={{ textAlign: 'center', marginBottom: 15, marginTop: 10 }}>
                                                                    {!isExpired ? <OtpTimer duration={10} onExpire={handleOtpExpired} /> : <div className={'resendOtp'}>
                                                                        <p>If you didn't receive OTP :</p> <button type="button" onClick={() => resentOtp(verificationEmail)} >Resend</button>
                                                                    </div>}
                                                                </div>

                                                                <div style={{ margin: '0px auto 15px', display: "flex", alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                                                    <button className="t_primary_btn t_full_width " type="submit" disabled={isLoading} style={{ maxWidth: 100 }}>
                                                                        {isLoading ? <><Spinner animation="border" variant="light" size="sm" /> Please wait.. </> : 'Continue'}
                                                                    </button>

                                                                </div>
                                                            </>
                                                        }


                                                    </form>
                                                )}
                                            </Formik>
                                        </div> : <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                                email: user.email || '',
                                            }}
                                            validate={(values) => {
                                                const errors = {};


                                                if (!values.email) {
                                                    errors.email = "Email is required";
                                                } else if (
                                                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                                                ) {
                                                    errors.email = "Invalid email address";
                                                }


                                                return errors;
                                            }}
                                            onSubmit={handleVerification}
                                        >
                                            {({
                                                values,
                                                errors,
                                                touched,
                                                handleChange,
                                                handleBlur,
                                                setFieldValue,
                                                setFieldTouched,
                                                handleSubmit,
                                                isSubmitting,
                                                setFieldError
                                            }) => {
                                                return (
                                                    <form onSubmit={handleSubmit}>
                                                        <p className="pb-2" style={{ fontSize: 14 }}>If you'd like to continue with this email, no action is needed. Otherwise, enter a new one.</p>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Email"
                                                            name="email"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.email}

                                                        />
                                                        <ErrorMessage className="help-error" name="email" component="div" />

                                                        <div className="text-center mt-3">
                                                            <button
                                                                type="submit"
                                                                className="t_primary_btn "
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? "Please wait..." : "Send Verification OTP"}
                                                            </button>
                                                        </div>

                                                    </form>
                                                );
                                            }}
                                        </Formik>
                                    }
                                </ThemeModal>
                            </>
                        }

                    </Card.Body>
                </Card>
            </div>
        </div>

        </>
    );
};

export default UserSingle;
